import React from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useLanguage } from '../context/LanguageContext';

const jacuzziImages = require.context('../images/jacuzzi', false, /\.(png|jpe?g|svg)$/);

function JacuzziSuite() {
    const { isEnLang } = useLanguage();
    const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

    const text = {
        en: {
            label: 'Exclusive Suite',
            title: 'The Jacuzzi Suite',
            description: 'Immerse yourself in an unforgettable experience in our exclusive Jacuzzi Suite. Chromotherapy LED lighting, a large built-in jacuzzi, a private living area with sofa and Smart TV — every detail designed for your maximum relaxation.',
            features: ['Built-in Jacuzzi', 'Chromotherapy LED', 'Smart TV & Netflix', 'Private living area'],
            cta: 'Book the Suite',
            more: 'Discover More',
        },
        it: {
            label: 'Suite Esclusiva',
            title: 'La Suite Jacuzzi',
            description: "Immergiti in un'esperienza indimenticabile nella nostra esclusiva Suite Jacuzzi. Luci LED cromoterapia, ampia vasca idromassaggio integrata, zona living privata con divano e Smart TV — ogni dettaglio pensato per il tuo massimo relax.",
            features: ['Vasca Idromassaggio', 'LED Cromoterapia', 'Smart TV & Netflix', 'Zona living privata'],
            cta: 'Prenota la Suite',
            more: 'Scopri di più',
        },
    };

    const { label, title, description, features, cta, more } = isEnLang ? text.en : text.it;

    const sliderSettings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 900,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        dotsClass: 'slick-dots custom-dots',
    };

    return (
        <section id="jacuzzi" className="jacuzzi-suite">
            <motion.div
                ref={ref}
                className="jacuzzi-inner l-1260"
                initial={{ opacity: 0, y: 48 }}
                animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 48 }}
                transition={{ duration: 0.75 }}
            >
                <div className="jacuzzi-photos">
                    <Slider {...sliderSettings}>
                        {jacuzziImages.keys().map((img, i) => (
                            <div key={i}>
                                <img
                                    src={jacuzziImages(img)}
                                    alt={`Suite Jacuzzi B&B Alma Suite Anzio ${i + 1}`}
                                />
                            </div>
                        ))}
                    </Slider>
                </div>

                <div className="jacuzzi-text">
                    <span className="jacuzzi-label">{label}</span>
                    <h2>{title}</h2>
                    <p>{description}</p>
                    <ul className="jacuzzi-features">
                        {features.map((f, i) => (
                            <li key={i}>
                                <span className="jacuzzi-check">✓</span> {f}
                            </li>
                        ))}
                    </ul>
                    <div className="jacuzzi-ctas">
                        <a
                            href={`https://wa.me/+393928729907?text=${encodeURIComponent("Salve, vorrei prenotare la Suite Jacuzzi. www.almasuitebb.it")}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="jacuzzi-cta primary"
                        >
                            {cta}
                        </a>
                        <Link to="/suite-jacuzzi" className="jacuzzi-cta secondary">
                            {more}
                        </Link>
                    </div>
                </div>
            </motion.div>
        </section>
    );
}

export default JacuzziSuite;
